/**
 * Generated by `./scripts/prebuild/generate-icons-experimental.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React from 'react';
import { Experimental__IconExternalLink } from "../../Experimental__Icon/icons/Experimental__IconExternalLink";
export function IconExternalLink(props) {
  return /*#__PURE__*/React.createElement(Experimental__IconExternalLink, props);
}
export default IconExternalLink;